<script setup lang="ts">
defineProps<{
  text?: string;
}>();
</script>

<template>
  <p class="mx-3 text-muted mb-1">
    <slot>{{ text }}</slot>
  </p>
</template>

